<script setup lang="ts">
import { UiAside, UiText, UiSquareButton } from "@shopexperts/shared";
import LeadSubmissionForm from "@/app/components/LeadSubmissionForm.vue";
import ExpertProjectInviteForm from "@/app/components/ExpertProjectInviteForm.vue";
defineProps<{ threadId: string; peerName: string; side: "client" | "expert" }>();
const open = defineModel<boolean>({ default: false });
</script>
<template>
  <UiAside v-model="open" position="right">
    <div v-if="open" class="flex h-full flex-col">
      <div class="flex shrink-0 items-center justify-between gap-3 border-b border-se-gray-200 bg-white px-6 py-4">
        <div class="min-w-0">
          <UiText as="h2" variant="h4" text="Start a project" />
          <UiText as="p" variant="p-small" :text="`With ${peerName} · Shared in this conversation`" class="truncate text-se-gray-600" />
        </div>
        <UiSquareButton icon="close" aria-label="Close project form" class="shrink-0" @click="open = false" />
      </div>
      <div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto overscroll-contain p-6">
      <LeadSubmissionForm v-if="side === 'client'" :direct-thread-id="threadId" :direct-peer-name="peerName" disable-auto-redirect @success="open = false" />
      <ExpertProjectInviteForm v-else :direct-thread-id="threadId" :peer-name="peerName" @submitted="open = false" @close="open = false" />
      </div>
    </div>
  </UiAside>
</template>
